import { TipoDefinicion, TipoDefinicionJSON } from '../TipoDefinicion/TipoDefinicion';

export interface TipoDefinicionXTorneoJSON {
  tdxt_id: string | null;
  tdxt_torid: number;
  tdxt_tdid: number;
  tdxt_orden_prioridad: number;
  tipoDefinicion: TipoDefinicionJSON;
  __delete: boolean;
}

export class TipoDefinicionXTorneo {
  protected constructor(
    private id: string | null,
    private torid: number,
    private tdid: number,
    private ordenPrioridad: number,
    private tipoDefinicion: TipoDefinicion,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    torid: number,
    tdid: number,
    ordenPrioridad: number,
    tipoDefinicion: TipoDefinicion,
    __delete: boolean
  ) {
    return new this(id, torid, tdid, ordenPrioridad, tipoDefinicion, __delete);
  }

  tipoDefinicionIs(td: TipoDefinicion): boolean {
    return td.isIdentifiedBy(String(this.tdid));
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TipoDefinicionXTorneo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TipoDefinicionXTorneoJSON) {
    return TipoDefinicionXTorneo.createFrom(
      entity.tdxt_id,
      entity.tdxt_torid,
      entity.tdxt_tdid,
      entity.tdxt_orden_prioridad,
      TipoDefinicion.fromJSON(entity.tipoDefinicion),
      entity.__delete
    );
  }

  toJSON(): TipoDefinicionXTorneoJSON {
    return {
      tdxt_id: this.getId(),
      tdxt_torid: this.getTorid(),
      tdxt_tdid: this.getTdid(),
      tdxt_orden_prioridad: this.getOrdenPrioridad(),
      tipoDefinicion: this.getTipoDefinicion().toJSON(),
      __delete: this.get__delete(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getTorid(): number {
    return this.torid;
  }

  getTdid(): number {
    return this.tdid;
  }

  getOrdenPrioridad(): number {
    return this.ordenPrioridad;
  }
  getTipoDefinicion(): TipoDefinicion {
    return this.tipoDefinicion;
  }

  get__delete(): boolean {
    return this.__delete;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setTorid(value: number): void {
    this.torid = value;
  }

  setTdid(value: number): void {
    this.tdid = value;
  }

  setOrdenPrioridad(value: number): void {
    this.ordenPrioridad = value;
  }
}
